module.exports = __webpack_public_path__ + "img/DCI.c9f76a3c.png";